import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import NavigationItemTranslation from '@/repositories/data/sidebar/NavigationItemTranslation';

export default class NavigationItemTranslationRepository extends BaseCrudRepository<
    number,
    NavigationItemTranslation,
    NavigationItemTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/navigation-item-translation/');
    }
}
